import { render, staticRenderFns } from "./UserCv.vue?vue&type=template&id=f16fdc08&scoped=true&"
import script from "./UserCv.vue?vue&type=script&lang=js&"
export * from "./UserCv.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/user-cv.scss?vue&type=style&index=0&id=f16fdc08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16fdc08",
  null
  
)

export default component.exports